import { render, staticRenderFns } from "./ModalRetainFile.vue?vue&type=template&id=37bc703c&"
import script from "./ModalRetainFile.vue?vue&type=script&lang=js&"
export * from "./ModalRetainFile.vue?vue&type=script&lang=js&"
import style0 from "./ModalRetainFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37bc703c')) {
      api.createRecord('37bc703c', component.options)
    } else {
      api.reload('37bc703c', component.options)
    }
    module.hot.accept("./ModalRetainFile.vue?vue&type=template&id=37bc703c&", function () {
      api.rerender('37bc703c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/modals/ModalRetainFile.vue"
export default component.exports